/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date: Mon Apr 22 2024 10:55:53
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { useEffect } from 'react';
import { TextField } from '@shopify/polaris';
import { RenderLabelTooltip } from './render-label-tooltip';
import ReactTooltip from 'react-tooltip';

export const RenderTextFieldWithIcon = (field: Object) => {
  const { input } = field;
  let { value } = input;
  value = _.isNil(value) ? value : value.toString();

  useEffect(() => {
    return () => {
      field.onUnmount && field.onUnmount();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <RenderLabelTooltip label={field.label} tooltip={field.tooltip} />
      <div className="textfield-with-icon">
        <TextField
          id={field.input.name}
          value={value}
          type={field.type}
          min={field.min}
          max={field.max}
          onChange={field.input.onChange}
          onFocus={field.input.onFocus}
          placeholder={field.placeholder ? field.placeholder : ''}
          error={!!field.meta.error && !!field.meta.touched ? field.meta.error : ''}
          onBlur={field.input.onBlur}
          {...field.anotherProps}
        />
        <div className="textfield-with-icon--img">
          <img
            width={field.iconSize}
            height={field.iconSize}
            src={field.icon}
            alt=""
            onClick={field.iconOnClick}
            data-for="textfield-icon-tooltip"
            data-tip="dummy data"
          />
          {field.iconTooltip && (
            <ReactTooltip
              id="textfield-icon-tooltip"
              className="extraTooltipClass Polaris-Tooltip-TooltipOverlay Polaris-Tooltip-TooltipOverlay--positionedAbove"
              delayHide={500}
              effect="solid"
              type="light"
              getContent={function () {
                return (
                  <div className="Polaris-Tooltip-TooltipOverlay__Content">{field.iconTooltip}</div>
                );
              }}
              place="bottom"
            />
          )}
        </div>
      </div>
    </div>
  );
};
